import { Injectable } from '@angular/core';

@Injectable()
export class AppLoadingService {
  readonly mainLoaderClass = 'ti-loading';
  readonly secondLoaderClass = 'ti-loading-with-header';
  readonly mainMaskClass = 'ti-mask';
  readonly secondMaskClass = 'ti-mask-with-header';
  private mainMode = true;

  toggleMode() {
    this.mainMode = !this.mainMode;
  }

  showLoading() {
    this.show(this.mainLoaderClass, this.secondLoaderClass);
  }

  hideLoading() {
    this.hide(this.mainLoaderClass, this.secondLoaderClass);
  }

  showMask() {
    this.show(this.mainMaskClass, this.secondMaskClass);
  }

  hideMask() {
    this.hide(this.mainMaskClass, this.secondMaskClass);
  }

  showViewportLoading() {
    document.body.classList.add(this.mainLoaderClass);
  }

  private show(mainClass: string, secondClass: string) {
    const loaderClass = this.mainMode ? mainClass : secondClass;

    this.hideLoading();
    document.body.classList.add(loaderClass);
  }

  private hide(mainClass: string, secondClass: string) {
    document.body.classList.remove(mainClass);
    document.body.classList.remove(secondClass);
  }
}
